import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initSentry } from './config/sentry';

import './index.css';

initSentry();

createRoot(document.getElementById('root')!).render(<App />);

if ('serviceWorker' in navigator) {
  // Service worker registration can reject for reasons outside our control:
  // extensions blocking SWs, enterprise policies, partitioned storage, etc.
  // The PWA plugin's auto-injected /registerSW.js has no .catch() so its
  // rejections show up in Sentry as unhandled - we register manually here
  // (with injectRegister: false in vite.config.ts) so we can swallow them.
  // The app works fine without a SW, just no push notifications or offline
  // caching.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('Service worker registration failed', err);
    });
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .catch((err) => {
        console.warn('Firebase messaging SW registration failed', err);
      });
  });
}
